import { isPsP } from '@/enums/business-model.enum'
import { isBoleto, isPix } from '@/enums/payment-method.enum'

export const INSIGHTS_ACTIONS_ENUM = {}

const PENDING_STATUS = ['pending', 'pendente']

const simulatorPaymentsEnabled = ({
  status,
  businessModel,
  isTestAccount,
  paymentMethod
}) => {
  const isPendingStatus = PENDING_STATUS.includes(status.toLowerCase())
  return (
    isTestAccount &&
    isPendingStatus &&
    isPsP(businessModel) &&
    (isBoleto(paymentMethod) || isPix(paymentMethod))
  )
}

export { simulatorPaymentsEnabled }
